<template>
<div class="network-info">
   <div class="title">
    <span>{{$t('lang.network.networkInfo')}}</span>
  </div>
  <div class="network-form">
    <el-form :inline="true" label-position="right" label-width="150px">
      <el-row>
        <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.interfaceName')}：`" >
            <span>{{networkInfo.ifname}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.enableStatus')}：`">
            <div v-if="networkInfo.status == 1">
              <span class="badge-status-badge-status" ></span>
              <span style="margin-left: 5px">{{$t('lang.network.enabled')}}</span>
            </div> 
            <div v-else-if="networkInfo.status == 0">
              <span class="badge-status-badge-error" ></span>
              <span style="margin-left: 5px">{{$t('lang.network.disable')}}</span>
            </div> 
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.ipAddress')}：`">
            <span>{{networkInfo.ipaddr}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.subnetMask')}：`">
            <span>{{networkInfo.netmask}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.gateway')}：`" >
            <span>{{networkInfo.gateway}}</span>
          </el-form-item>
        </el-col>
         <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.protocal')}：`">
            <span>{{protoOptions[networkInfo.proto]}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
         <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.connectTime')}：`">
            <span>{{getSecond(networkInfo.connTime)}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.DNSServer')}：`">
            <span>{{networkInfo.dns}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.hops')}：`">
            <span>{{networkInfo.metric}}</span>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item :label="`${$t('lang.network.upstreamTraffic')}：`">
            <span>{{getTraffic(networkInfo.tx_bytes)}}</span>
          </el-form-item>
        </el-col>
        <el-col :span="8">
           <el-form-item :label="`${$t('lang.network.downstreamTraffic')}：`">
            <span>{{getTraffic(networkInfo.rx_bytes)}}</span>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</div>
 
</template>
<script>
import { getOnlineTime, SecondToDate } from '@/utils/Date.js'
export default {
  props: ['networkInfo'],
  data() {
    return {
      protoOptions: {
        static: this.$t('lang.network.staticAddress'),
        l2tp: 'L2TP',
        pptp: 'PPTP',
        dhcp: 'DHCP',
        '3g': 'PPP'
      },
      timer: null
    }
  },
  methods: {
    //计算毫秒数
    getSecond(msd) {
      return SecondToDate(msd)
    },
    // 计算流量
    getTraffic(byte) {
      return getOnlineTime(byte)
    }
  }
}
</script>
<style scoped>
.el-form-item{
  margin-bottom: 0px;
}
.badge-status-badge-status{
  width: 10px;
  height: 10px;
  background-color: #67c23a;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}
.badge-status-badge-error{
  width: 10px;
  height: 10px;
  background-color: #f56c6c;
  position: relative;
  top: -1px;
  display: inline-block;
  vertical-align: middle;
  border-radius: 50%;
}
.title{
  height: 35px;
  line-height: 35px;
  font-size: 16px;
  margin-bottom: 10px;
  background-color: #f0f2f5;
  padding-left: 10px;
  color: rgb(141, 133, 133);
}
</style>